export default __webpack_public_path__ + "static/media/logo-app.2df0b742.png";